<template>
  <div class="app-main-content">
    <document-tree-grid
      v-show="view==='list'"
      ref="documentTreeGrid"
      :context="context"
      @look="lookHandle"
      @edit="editHandle"
      @refresh="refreshHandle"
    />
    <document-workspace
      v-show="view==='detail'"
      ref="documentWorkspace"
      :parent-context="context"
      @back="backToList"
    />
  </div>
</template>

<script>
import { DocumentContext } from './components/document/documentContext'
import documentTreeGrid from './components/document/documentTreeGrid'
import documentWorkspace from './components/document/documentWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'

export default {
  name: 'Document',
  components: { documentTreeGrid, documentWorkspace },
  data() {
    return {
      context: DocumentContext.getInstance(),
      view: 'list'
    }
  },
  computed: {
    office() {
      return this.context.office
    }
  },
  created() {
    this.context.prepareData()
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        this.$refs.documentTreeGrid.toQuery()
      }
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.documentWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.documentTreeGrid.rowData
      }
      this.$refs.documentWorkspace.onShow(type, rowData, row)
    },
    // 操作成功后刷新详情
    refreshHandle(row) {
      row.isCompleteRow = false
      this.detailHandle('look', row)
    }
  }
}
</script>
